import type { DashboardData } from '../../services/dashboard.service';

export function formatDashboardCurrency(amount: number): string {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}

export function formatDashboardDate(iso: string | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('es-MX', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

export function sparklineDataset(
  kind: 'up' | 'down' | 'neutral',
  color: string
): { labels: string[]; datasets: { data: number[]; backgroundColor: string; borderWidth: number }[] } {
  const up = [0.4, 0.55, 0.5, 0.7, 0.65, 0.85, 0.8, 1];
  const down = [0.9, 0.75, 0.8, 0.6, 0.65, 0.5, 0.45, 0.35];
  const neutral = [0.5, 0.6, 0.55, 0.65, 0.6, 0.7, 0.65, 0.6];
  const values = kind === 'up' ? up : kind === 'down' ? down : neutral;
  return {
    labels: values.map((_, i) => String(i)),
    datasets: [{ data: values, backgroundColor: color, borderWidth: 0 }]
  };
}

export const CHART_SPARKLINE_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: {
    x: { display: false },
    y: { display: false, beginAtZero: true, max: 1 }
  }
};

export function heatMapCells(
  data: DashboardData | null
): { date: string; amount: number; count: number; intensity: number }[] {
  const d = data?.heatMapData ?? [];
  const max = Math.max(1, ...d.map((x) => x.amount));
  return d.slice(-56).map((x) => ({
    ...x,
    intensity: Math.min(1, x.amount / max)
  }));
}

export function invoicesByStatusEntries(
  data: DashboardData | null
): { key: string; value: number }[] {
  const status = data?.invoicesByStatus;
  if (!status) return [];
  return Object.entries(status).map(([key, value]) => ({ key, value }));
}
